/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * When was the entity created
     * @type {Date}
     * @memberof Tag
     */
    createdAt: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof Tag
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    ownerId: string;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    tagType: TagTagTypeEnum;
}

export function TagFromJSON(json: any): Tag {
    return TagFromJSONTyped(json, false);
}

export function TagFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'id': json['id'],
        'name': json['name'],
        'ownerId': json['owner_id'],
        'tagType': json['tag_type'],
    };
}

export function TagToJSON(value?: Tag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'id': value.id,
        'name': value.name,
        'owner_id': value.ownerId,
        'tag_type': value.tagType,
    };
}

/**
* @export
* @enum {string}
*/
export enum TagTagTypeEnum {
    NORMAL = 'NORMAL',
    VENDOR = 'VENDOR',
    VRM = 'VRM'
}


